
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment créer un site Internet de taxi ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez développer la clientèle et le chiffre d’affaires de votre société de taxi ? Alors vous devez développer votre présence en ligne et notamment créer un site Internet.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Comment créer un site Internet de taxi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez développer la clientèle et le chiffre d’affaires de votre société de taxi ? Alors vous devez développer votre présence en ligne et notamment créer un site Internet.",
        },
      ],
    };
  },
};
